import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, CardContent, CircularProgress, Divider, Typography } from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import { useLazyGetLicitacaoAnexosQuery } from '../licitacaoAnexoApiSlice';
import { LicitacaoList } from '../types/Licitacao';
import { LicitacaoAnexo } from '../types/LicitacaoAnexo';

interface LicitacaoCardProps {
  licitacao: LicitacaoList;
}

export default function LicitacaoPublicCardForm({ licitacao }: LicitacaoCardProps) {
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);
  const [fetchAnexos, { data: dataAnexo, isLoading }] = useLazyGetLicitacaoAnexosQuery();

  const handleAccordionChange = (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded);
    if (isExpanded && !dataAnexo) {
      fetchAnexos({ idLicitacao: licitacao.id || '' });
    }
  };

  //quero que seja carregado os anexos apenas quando clicar para expandir o accordion do anexo
  //  const { data: dataAnexo } = useGetLicitacaoAnexosQuery({ idLicitacao: licitacao.id || '' }, { skip: !licitacao.id });

  if (!licitacao) {
    return <div>Erro: dados não carregados!</div>;
  }

  return (
    <Card key={licitacao.id} id={licitacao.id} sx={{ width: '100%', mt: 1 }}>
      <CardContent sx={{ p: 1 }}>
        {/* Linha 1 */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 0.5, mb: 0.5 }}>
          <Typography variant="caption" color="secondary">
            Data: {licitacao?.dataHoraCriacao ? new Date(licitacao?.dataHoraCriacao).toLocaleDateString() : ''}
          </Typography>
          <Typography variant="caption" color="secondary">
            Processo: {licitacao?.processo}
          </Typography>
          <Typography variant="caption" color="secondary">
            Pregão: {licitacao?.pregao}
          </Typography>
        </Box>

        {/* Linha 2 */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', pb: 0.5, mb: 0.5 }}>
          <Typography variant="caption" color="secondary">
            Modalidade: {licitacao.modalidade.nome}
          </Typography>
          <Typography variant="caption" color="secondary">
            Situação: {licitacao.situacao.nome}
          </Typography>
          <Typography variant="caption" color="secondary">
            Fiscal: {licitacao.fiscal}
          </Typography>
        </Box>

        {/* Linha 3 (Objeto em destaque, sem borda embaixo) */}
        <Box sx={{ display: 'flex' }}>
          <Typography variant="caption" color="primary" sx={{ fontWeight: 600 }}>
            Objeto: {licitacao.objeto}
          </Typography>
        </Box>
      </CardContent>
      {licitacao.temAnexo && (
        <>
          <Divider />
          <Box>
            <Accordion defaultExpanded={false} expanded={expanded} onChange={handleAccordionChange}>
              <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                <PushPinOutlinedIcon fontSize="small" color="action" sx={{ mr: 0.5 }} />
                <Typography color="primary" variant="body1" gutterBottom>
                  Anexos
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                {isLoading && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2 }}>
                    <CircularProgress size={24} />
                    <Typography sx={{ ml: 1 }} variant="body2" color="textSecondary">
                      Carregando anexos...
                    </Typography>
                  </Box>
                )}

                {!isLoading && dataAnexo?.length === 0 && <Typography>Nenhum anexo disponível</Typography>}

                {!isLoading &&
                  dataAnexo?.map((file: LicitacaoAnexo) => (
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Box>
                        <Typography variant="body2" color="secondary">
                          {file.nomeOriginal}
                        </Typography>
                      </Box>
                      <Box>
                        <DownloadAnexoButton tipo={'LICITACAO'} ida={file.path} fileName={file.nomeOriginal} />
                      </Box>
                    </Box>
                  ))}
              </AccordionDetails>
            </Accordion>
          </Box>
        </>
      )}
    </Card>
  );
}
